/* RESSPIRE — thème Shopify intégré.
   (a) menu burger · (b) accordéon FAQ · (c) galerie produit · (d) logique variante produit.
   Vanilla JS, robuste si les éléments n'existent pas (pages sans produit). */
(function () {
  document.addEventListener('DOMContentLoaded', function () {

    /* (a) Menu burger */
    var burger = document.getElementById('burger');
    var snav = document.getElementById('siteNav');
    if (burger && snav) {
      burger.addEventListener('click', function () { snav.classList.toggle('is-open'); });
    }

    /* (b) Accordéon FAQ */
    document.querySelectorAll('.accordion__head').forEach(function (h) {
      h.addEventListener('click', function () {
        var acc = h.closest('.accordion');
        if (!acc) return;
        var body = acc.querySelector('.accordion__body');
        var open = acc.classList.toggle('is-open');
        if (body) body.style.maxHeight = open ? (body.scrollHeight + 'px') : '0';
      });
    });

    /* (c) Galerie (thumb → main) */
    var galleryMain = document.getElementById('galleryMain');
    document.querySelectorAll('.gallery__thumbs img').forEach(function (t) {
      t.addEventListener('click', function () {
        if (galleryMain) galleryMain.src = t.getAttribute('data-full') || t.src;
        document.querySelectorAll('.gallery__thumbs img').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    /* (d) Logique variante produit */
    var variantSelect = document.getElementById('rs-variant');
    var form = document.getElementById('rs-form');
    if (variantSelect && form) {
      var priceEl = document.getElementById('rs-price');
      var priceStickyEl = document.getElementById('rs-price-sticky');
      var packCards = document.querySelectorAll('.pack-card');
      var colorOpts = document.querySelectorAll('.color-opt');

      var state = { pack: null, color: null };
      var defaultImg = galleryMain ? galleryMain.getAttribute('src') : '';

      function findOption(pack, color) {
        var opts = variantSelect.options;
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].getAttribute('data-q') === pack && opts[i].getAttribute('data-c') === color) {
            return opts[i];
          }
        }
        return null;
      }

      function sync() {
        if (state.pack === null || state.color === null) return;
        var opt = findOption(state.pack, state.color);
        if (!opt) return;
        variantSelect.value = opt.value;
        var price = opt.getAttribute('data-price') || '';
        if (priceEl) priceEl.textContent = price;
        if (priceStickyEl) priceStickyEl.textContent = price;
        // Photo du lot sélectionné (fallback image par défaut si la variante n'a pas d'image, ex. pack 2 sachets)
        if (galleryMain) {
          var img = opt.getAttribute('data-img');
          galleryMain.src = (img && img.length) ? img : defaultImg;
          document.querySelectorAll('.gallery__thumbs img').forEach(function (x) { x.classList.remove('is-active'); });
        }
        // Mention "livraison offerte" sur le bouton uniquement si le pack y a droit (≥ 39 €)
        var free = opt.getAttribute('data-free') === '1';
        document.querySelectorAll('.js-buy-btn').forEach(function (b) {
          b.textContent = 'Ajouter au panier' + (free ? ' — livraison offerte' : '');
        });
      }

      packCards.forEach(function (el) {
        el.addEventListener('click', function () {
          packCards.forEach(function (x) { x.classList.remove('is-selected'); });
          el.classList.add('is-selected');
          state.pack = el.getAttribute('data-pack');
          sync();
        });
      });

      colorOpts.forEach(function (el) {
        el.addEventListener('click', function () {
          colorOpts.forEach(function (x) { x.classList.remove('is-selected'); });
          el.classList.add('is-selected');
          state.color = el.getAttribute('data-color');
          sync();
        });
      });

      /* Initialisation : pack présélectionné (3 sachets) + Noir */
      var initPack = document.querySelector('.pack-card.is-selected');
      if (initPack) state.pack = initPack.getAttribute('data-pack');
      else if (packCards.length) state.pack = packCards[0].getAttribute('data-pack');

      var initColor = document.querySelector('.color-opt.is-selected');
      if (initColor) state.color = initColor.getAttribute('data-color');
      else if (colorOpts.length) state.color = colorOpts[0].getAttribute('data-color');

      sync();
    }

  });
})();
